import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { v4 as uuidv4 } from "uuid";
import isEmpty from "lodash/isEmpty";
import HomeDocumentSectionItem from "./home-document-section-item";
import { generatePdfThumbnail } from "helper/generate-pdf-thumbnail";
import * as CommonActionType from "../../../Common/constants";
import * as ProjectActionType from "../../constants";
import Moment from "moment";
import { Modal } from "react-bootstrap";
import * as LotActionType from "Lots/constants";
import folder from "assets/img/folder.png";
import word from "assets/img/file_word.png";
import excel from "assets/img/file_excel.png";
import pdf from "assets/img/file_pdf.png";
import ppt from "assets/img/file_pp.png";
import video from "assets/img/file_video.png";
import other from "assets/img/file_other.png";
import AddDocumentModal from "../../../Lots/Components/AddDocumentModal";
import EditDocumentModal from "../../../Lots/Components/EditDocumentModal";

const MAXIMUM_VIDEO_SIZE = 1024 * 1024 * 500;

class HomeDocumentSection extends Component {
  static propTypes = {
    projectId: PropTypes.string,
    documentTypeId: PropTypes.string,
    dispatch: PropTypes.func,
    user: PropTypes.object,
    ProjectDocument: PropTypes.object,
    lot: PropTypes.object,
    documents: PropTypes.array,
    hidden: PropTypes.bool,
    manualType: PropTypes.number,
    documentType: PropTypes.object,
    getDocumentByCategory: PropTypes.func,
    fetchListDocumentType: PropTypes.func,
  };

  constructor(props) {
    super(props);
    this.AWSCredential = null;
    this.state = {
      files: [],
      cancelUploadList: {},
      deleteUploadList: {},
      showModal: false,
      uploadedFiles: [],
      showEditModal: false,
      menuOpenId: null,
      selectedDocument: null,
      loadingDocument: true,
      showConfirmDeleteModal: false,
      documentToDelete: null,
      previewDocument: null,

      previewModalOpen: false,
      previewContent: null,
      previewType: null,
    };
  }

  componentDidMount() {
    this.setState({ loadingDocument: true });
  }

  componentWillReceiveProps(nextProps) {
    if (!nextProps.hidden && nextProps.hidden !== this.props.hidden) {
      this.onLoadDocument();
    }
  }

  onLoadDocument = () => {
    this.setState({
      loadingDocument: true,
    });
  };

  // function for edit document
  toggleMenu = (id) => {
    this.setState((prevState) => ({
      menuOpenId: prevState.menuOpenId === id ? null : id,
    }));
  };

  handleEdit = (document) => {
    this.setState({
      selectedDocument: document,
      showEditModal: true,
      menuOpenId: null,
    });
  };

  handleDelete = (document) => {
    this.setState({
      showConfirmDeleteModal: true,
      documentToDelete: document,
      menuOpenId: null,
    });
  };

  getFileType = (item) => {
    if (!item) return 'other';

    const fileName = item.fileName || item.name || '';
    if (!fileName) return 'other';

    const ext = fileName.split('.').pop().toLowerCase();

    if (['doc', 'docx'].includes(ext)) return 'word';
    if (['xls', 'xlsx'].includes(ext)) return 'excel';
    if (['ppt', 'pptx'].includes(ext)) return 'ppt';
    if (['mp4', 'm4v', 'mid', 'mkv', 'webm', 'mov', 'avi', 'wmv'].includes(ext)) return 'video';
    if (ext === 'pdf') return 'pdf';
    if (['jpg', 'jpeg', 'png', 'gif'].includes(ext)) return 'image';
    return 'other';
  };

  closeEditModal = () => {
    this.setState({ showEditModal: false, selectedDocument: null });
  };

  openPreview = (doc) => {
    const url = doc.textAndUrl || doc.url || doc.documentUrl || '';
    const fileName = doc.fileName || doc.name || 'Document';
    const fileType = this.getFileType(doc);

    this.setState({
      previewModalOpen: true,
      previewContent: {
        url,
        fileName,
        type: fileType
      }
    });
  };

  closePreview = () => {
    this.setState({
      previewModalOpen: false,
      previewContent: null
    });
  };

  renderLinkContent = (docs, label) => {
    const isValidLink = (text) => {
      if (!text) return false;
      try {
        const urlRegex = /^https?:\/\/[^\s]+$/gi;
        const isCleanUrl = urlRegex.test(text);
        if (!isCleanUrl) {
          const containsUrl = /https?:\/\/[^\s]+/gi.test(text);
          return containsUrl;
        }
        return true;
      } catch (e) {
        return false;
      }
    };

    const shouldOpenInNewTab = (doc) => {
      if (!doc) return false;
      const url = doc.textAndUrl || doc.url || doc.documentUrl || '';
      if (!url) return false;
      const extension = url.split('.').pop().toLowerCase();
      const newTabExtensions = ['jpg', 'jpeg', 'png', 'gif', 'svg', 'webp', 'pdf', 'mp4', 'webm', 'mov', 'avi', 'doc', 'docx', 'xls', 'xlsx', 'ppt', 'pptx', 'txt'];
      return newTabExtensions.includes(extension);
    };

    return (
      <div className="form-group link-document-fields">
        {label && <label style={{ fontWeight: "bold" }}>{label}</label>}
        <div style={{ marginTop: label ? "20px" : "0" }}>
          {docs.map((doc, index) => {
            const displayText = doc.fileName || doc.name || doc.textAndUrl || "";
            const linkContent = doc.textAndUrl || doc.url || doc.documentUrl || '';
            const fileTypeIcon = this.renderFileTypeIcon(doc);
            const validLink = isValidLink(linkContent);
            const openInNewTab = shouldOpenInNewTab(doc);
            const updatedBy = doc.updatedBy || "Club Matridis";
            const updatedDate = doc.updatedDate || doc.createdDate;

            return (
              <div key={index} className="document-item-container">
                <div className="document-item-content">
                  <img
                    src={fileTypeIcon}
                    alt="file type"
                    className="doc-icon"
                    style={{
                      width: "45px",
                      height: "45px"
                    }}
                  />
                  {validLink && !openInNewTab ? (
                    <a
                      href={linkContent}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="document-link"
                      style={{ textDecoration: 'none', color: 'inherit' }}
                      title={linkContent}
                    >
                      <div className="document-info">
                        <div className="document-name">{displayText}</div>
                        <div className="document-meta">
                          {Moment(updatedDate).format("MM/DD/YYYY")}
                        </div>
                      </div>
                    </a>
                  ) : (
                    <div
                      className={`document-link ${validLink ? 'clickable' : ''}`}
                      onClick={() => {
                        if (validLink && openInNewTab) {
                          this.openPreview(doc);
                        }
                      }}
                      style={{ cursor: validLink ? 'pointer' : 'not-allowed' }}
                    >
                      <div className="document-info">
                        <div className="document-name">{displayText}</div>
                        <div className="document-meta">
                          {Moment(updatedDate).format("MM/DD/YYYY")}
                        </div>
                      </div>
                    </div>
                  )}
                  {doc.isBuilderDocument === false && (
                    <div className="document-actions">
                      <div className="btn-group edit-document">
                        <button
                          className="btn btn-default btn-sm dropdown-toggle"
                          type="button"
                          data-toggle="dropdown"
                          aria-haspopup="true"
                          aria-expanded="false"
                          onClick={(e) => {
                            this.toggleMenu(doc.id);
                          }}
                          style={{
                            outline: "none",
                            border: "none",
                          }}
                        >
                          <i className="fa fa-ellipsis-v menu-icon" aria-hidden="true"></i>
                        </button>
                        <ul className="dropdown-menu dropdown-menu-right">
                          <li
                            style={{
                              border: "none",
                            }}
                          >
                            <a onClick={(e) => {
                              this.handleEdit(doc);
                            }}>
                              <i className="fa fa-pencil" style={{ color: "#4a4a4a", marginRight: 5 }} />
                              Edit document
                            </a>
                          </li>
                          <li
                            style={{
                              border: "none",
                            }}
                          >
                            <a onClick={(e) => {
                              this.handleDelete(doc);
                            }} style={{ color: "red" }}>
                              <i className="fa fa-trash" style={{ marginRight: 5 }} aria-hidden="true"></i>
                              Delete document
                            </a>
                          </li>
                        </ul>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    );
  };

  renderPreviewModal = () => {
    const { previewModalOpen, previewContent } = this.state;
    if (!previewContent) return null;

    const fileExt = previewContent.url.split('.').pop().toLowerCase();
    const imageFiles = ['jpg', 'jpeg', 'png', 'gif', 'webp'];
    const videoFiles = ['mp4', 'webm', 'ogg', 'mov', 'avi'];
    const officeFiles = ['doc', 'docx', 'xls', 'xlsx'];

    const renderError = (message = "Failed to load preview.") => (
      <div className="unsupported-preview">
        <p>{message}</p>
        <button
          onClick={() => window.open(previewContent.url, '_blank')}
          className="btn btn-primary"
        >
          Open in New Tab
        </button>
      </div>
    );

    const renderOfficePreview = () => {
      const officeOnlineUrl = `https://view.officeapps.live.com/op/embed.aspx?src=${encodeURIComponent(previewContent.url)}`;
      return (
        <iframe
          src={officeOnlineUrl}
          style={{ width: '100%', height: '70vh', border: 'none' }}
          title={`Office Document Viewer - ${previewContent.fileName}`}
        />
      );

    };

    const renderPreview = () => {
      try {
        if (imageFiles.includes(fileExt)) {
          return (
            <img
              src={previewContent.url}
              alt={previewContent.fileName}
              style={{ maxHeight: '80vh', maxWidth: '100%' }}
            />
          );
        }
        if (videoFiles.includes(fileExt)) {
          return (
            <video
              controls
              style={{ maxWidth: '100%', maxHeight: '80vh' }}
            >
              <source src={previewContent.url} type={`video/${fileExt}`} />
              Your browser does not support the video tag.
            </video>
          );
        }
        if (fileExt === 'pdf') {
          return (
            <div style={{ height: '70vh', width: '100%' }}>
              <iframe
                src={previewContent.url}
                title={previewContent.fileName}
                className="pdf-iframe"
                frameBorder="0"
              />
            </div>
          );
        }
        if (officeFiles.includes(fileExt)) {
          return renderOfficePreview();
        }
        return renderError("Preview not available for this file type.");

      } catch (error) {
        return renderError();
      }
    };

    return (
      <Modal
        show={previewModalOpen}
        onHide={this.closePreview}
        centered
        className="custom-preview-modal"
        size="lg"
      >
        <Modal.Header closeButton>
          <Modal.Title>{previewContent.fileName}</Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ textAlign: 'center', minHeight: '500px' }}>
          {renderPreview()}
        </Modal.Body>
      </Modal>
    );
  };

  handleFileDrop = (files) => {
    this.setState({ uploadedFiles: files });
  };

  onDrop = (accepted, rejected) => {
    const { manualType } = this.props;

    if (rejected.length) {
      const errorMsg =
        manualType === 0
          ? "Only PDF, PNG, JPG, JPEG supported."
          : "Only MP4, MOV, WEBM supported.";
      this.setState({
        error: errorMsg,
      });
    } else {
      const acceptLength = manualType === 0 ? 3 : 1;
      if (accepted.length <= acceptLength) {
        if (manualType === 1 && accepted[0].size > MAXIMUM_VIDEO_SIZE) {
          this.setState({
            error: `File size must not exceed ${MAXIMUM_VIDEO_SIZE / (1024 * 1024)
              }MB.`,
          });
        } else {
          const currentFileState = [...this.state.files];

          this.setState(
            {
              files: currentFileState.concat(accepted),
              error: null,
            },
            () => this.handleFileUpload(accepted)
          );
        }
      } else {
        this.setState({
          error: `Maximum ${acceptLength} file${acceptLength === 1 ? "" : "s"
            } allowed at once.`,
        });
      }
    }
  };

  handleFileUpload = (files) => {
    const { projectId } = this.props;

    this.props.dispatch({
      type: CommonActionType.COMMON_SETUP_AWS_ASYNC,
      params: {
        resourcePath: `projects/${projectId}`,
      },
      callback: (awsCredential) => {
        this.awsCredential = awsCredential;

        files.map((file) => {
          file.uploadId = uuidv4();

          if (file.type === "application/pdf") {
            this.props.dispatch({
              type: CommonActionType.COMMON_UPLOAD_FILE_TO_S3_ASYNC,
              paramsUpload: {
                projectId,
                file,
                config: awsCredential,
              },
              callback: (status, callbackData) => {
                if (status === "pending") {
                  const { cancelUploadList } = this.state;
                  cancelUploadList[callbackData.uploadId] =
                    callbackData.cancelUpload;
                  this.setState({
                    cancelUploadList,
                  });
                } else if (status === "delete") {
                  const { deleteUploadList } = this.state;
                  deleteUploadList[callbackData.uploadId] =
                    callbackData.deleteFile;
                  this.setState({
                    deleteUploadList,
                  });
                } else if (status === true) {
                  callbackData.name = file.name;

                  const data = file.preview;

                  generatePdfThumbnail(
                    data,
                    this.handlePdfThumbnail,
                    callbackData
                  );
                }
              },
            });
          } else {
            this.props.dispatch({
              type: CommonActionType.COMMON_UPLOAD_FILE_TO_S3_ASYNC,
              paramsUpload: {
                projectId,
                file,
                config: awsCredential,
              },
              callback: (status, callbackData) => {
                callbackData.name = file.name;

                if (status === "pending") {
                  const { cancelUploadList } = this.state;
                  cancelUploadList[callbackData.uploadId] =
                    callbackData.cancelUpload;
                  this.setState({
                    cancelUploadList,
                  });
                } else if (status === "delete") {
                  const { deleteUploadList } = this.state;
                  deleteUploadList[callbackData.uploadId] =
                    callbackData.deleteFile;
                  this.setState({
                    deleteUploadList,
                  });
                } else if (status === true) {
                  this.uploadDocumentToServer(callbackData, callbackData);
                }
              },
            });
          }
        });
      },
    });
  };

  handlePdfThumbnail = (thumbnail, fileDataS3) => {
    const { projectId } = this.props;

    thumbnail.name = uuidv4();

    this.props.dispatch({
      type: CommonActionType.COMMON_UPLOAD_FILE_TO_S3_ASYNC,
      paramsUpload: {
        projectId,
        file: thumbnail,
        config: {
          ...this.awsCredential,
          path: `${this.awsCredential.path}/thumbnail`,
        },
      },
      callback: (status, callbackData) => {
        if (status === true) {
          this.uploadDocumentToServer(fileDataS3, callbackData);
        }
      },
    });
  };

  uploadDocumentToServer = (fileData, thumbnailData) => {
    const { projectId, documentTypeId } = this.props;

    this.props.dispatch({
      type: ProjectActionType.UPLOAD_PROJECT_DOCUMENT_TO_SERVER_ASYNC,
      params: {
        projectId,
        projectDocumentTypeId: documentTypeId,
        data: {
          fileName: fileData.name,
          key: fileData.data.Key,
          url: fileData.data.Location,
          thumbnailKey: thumbnailData.data.Key,
          thumbnailUrl: thumbnailData.data.Location,
        },
      },
      callback: (status, res) => {
        if (status) {
          this.setState({
            files: this.state.files.filter(
              (element) => element.name !== res.fileName
            ),
          });
        }
      },
    });
  };

  onCancelUpload = (fileData) => {
    const item = fileData.file;

    const { cancelUploadList } = this.state;
    if (
      !isEmpty(cancelUploadList) &&
      Object.keys(cancelUploadList).includes(item.uploadId)
    ) {
      cancelUploadList[item.uploadId]();
      delete cancelUploadList[item.uploadId];
      this.setState({
        files: this.state.files.filter(
          (element) => element.uploadId !== item.uploadId
        ),
        cancelUploadList,
      });
    }
    const { deleteUploadList } = this.state;
    if (
      !isEmpty(deleteUploadList) &&
      Object.keys(deleteUploadList).includes(item.uploadId)
    ) {
      deleteUploadList[item.uploadId]();
      delete deleteUploadList[item.uploadId];
      this.setState({
        files: this.state.files.filter(
          (element) => element.uploadId !== item.uploadId
        ),
        deleteUploadList,
      });
    }
  };

  removeFile = (id) => {
    const { lot } = this.props;
    const { builderProfile } = lot.extensionValue;

    this.props.dispatch({
      type: LotActionType.DELETE_HOMEOWNER_DOCUMENT_ASYNC,
      params: {
        headers: {
          url: builderProfile.builderHost,
        },
        documentID: id,
      },
      callback: () => {
        this.props.fetchListDocumentType();
      },
    });
  };

  onUpdateFileName = (projectDocumentId, data, callback) => {
    const { projectId, documentTypeId } = this.props;

    this.props.dispatch({
      type: ProjectActionType.UPDATE_PROJECT_DOCUMENT_NAME_ASYNC,
      params: {
        projectId,
        projectDocumentId,
        projectDocumentTypeId: documentTypeId,
        data,
      },
      callback,
    });
  };

  renderFileUploading = (files) => {
    const { user, projectId, manualType } = this.props;

    if (files.length) {
      return files.map((file, index) => {
        const data = {
          file,
          fileName: file.name,
          createdBy: user.fullName,
          numberOfSharedLots: 0,
        };
        return (
          <HomeDocumentSectionItem
            manualType={manualType}
            mode={projectId ? "project" : "lot"}
            loading
            key={index}
            data={data}
            onCancelUpload={this.onCancelUpload}
          />
        );
      });
    }

    return null;
  };

  renderFileTypeIcon = (item) => {
    const extWord = ["doc", "docx"];
    const extExcel = ["xls", "xlsx"];
    const extPpt = ["ppt", "pptx"];
    const extImage = ["jpg", "jpeg", "png", "gif"];
    const extVideo = ["mp4", "m4v", "mid", "mkv", "webm", "mov", "avi", "wmv"];
    const ext = item.fileName.split(".").pop().toLowerCase();
    if (extWord.includes(ext)) {
      return word;
    } else if (extExcel.includes(ext)) {
      return excel;
    } else if (extPpt.includes(ext)) {
      return ppt;
    } else if (extVideo.includes(ext)) {
      return video;
    } else if (ext === "pdf") {
      return pdf;
    } else if (extImage) {
      return item.documentUrl;
    } else {
      return other;
    }
  };

  renderProjectDocument = (documents) => {
    const files = documents || [];

    return (
      <ul className="document-list scrollable-modal-body">
        {this.renderLinkContent(files, "")}
      </ul>
    );
  };

  handleOpenModal = () => {
    this.setState({ showModal: true });
  };

  handleCloseModal = () => {
    this.setState({ showModal: false });
  };

  onClearError = () => {
    this.setState({ error: null });
  };

  renderNoFiles = () => {
    return (
      <div className="lot-document-no-files">
        <img className="lot-document-no-files-ic" src={folder} alt="no-files" />
        <p className="lot-document-no-files-text">No documents found.</p>
        <p className="lot-document-no-files-text">
          Tap on 'Add Document' to add here
        </p>
      </div>
    );
  };

  renderError = () => {
    const { error } = this.state;

    if (error) {
      setTimeout(this.onClearError, 5000);
      return (
        <div
          className="alert alert-danger"
          style={{ width: "100%", margin: "0 15px 15px" }}
        >
          <p style={{ fontSize: 14 }}>{error}</p>
          <i
            className="fa fa-close"
            style={{
              position: "absolute",
              top: 14,
              right: 14,
              cursor: "pointer",
            }}
            onClick={this.onClearError}
          />
        </div>
      );
    }

    return null;
  };

  render() {
    const {
      files,
      selectedProjectDocument,
      loadingDocument,
      selectedDocument,
    } = this.state;

    const { projectId, documentTypeId, documents, lot, documentType } =
      this.props;

    return (
      <div>
        <div className="lot-document-section-wrapper">
          {loadingDocument ? (
            <div className="project-document-loader">
              <div className="spinner-border text-primary" role="status">
                <span className="sr-only">Loading...</span>
              </div>
            </div>
          ) : (
            ""
          )}
          {this.renderError()}
          {documents && documents.length > 0
            ? this.renderProjectDocument(documents)
            : this.renderNoFiles()}
          {this.renderFileUploading(files)}
        </div>

        <button
          type="button"
          className="add-document-btn"
          onClick={this.handleOpenModal}
        >
          + Add Document
        </button>

        {selectedDocument && (
          <EditDocumentModal
            isOpen={this.state.showEditModal}
            closeModal={this.closeEditModal}
            onDrop={this.handleFileDrop}
            getDocumentByCategory={this.props.getDocumentByCategory}
            fetchListDocumentType={this.props.fetchListDocumentType}
            accept=".pdf,.docx,.png,.jpg"
            lot={lot}
            documentType={documentType}
            SelectedEditDocument={selectedDocument}
            mode="edit"
          />
        )}

        <AddDocumentModal
          isOpen={this.state.showModal}
          closeModal={this.handleCloseModal}
          onDrop={this.handleFileDrop}
          accept=".pdf,.docx,.png,.jpg"
          lot={lot}
          documentType={documentType}
          getDocumentByCategory={this.props.getDocumentByCategory}
          fetchListDocumentType={this.props.fetchListDocumentType}
        />

        {this.state.showConfirmDeleteModal && (
          <Modal
            dialogClassName="confirm-cancel-save-eoc-template-dialog"
            show={this.state.showConfirmDeleteModal}
            centered="true"
            size="sm"
          >
            <Modal.Header>
              <Modal.Title>Confirm Delete</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <p>Are you sure you want to delete this document?</p>
            </Modal.Body>
            <Modal.Footer>
              <div className="suspend-group-btn" style={{ float: "left" }}>
                <button
                  className="btn btn-danger"
                  onClick={() => {
                    const { documentToDelete } = this.state;

                    this.removeFile(documentToDelete.id);

                    this.setState({
                      showConfirmDeleteModal: false,
                      documentToDelete: null,
                    });
                  }}
                >
                  Yes, Delete
                </button>
                <button
                  className="btn btn-secondary"
                  onClick={() =>
                    this.setState({
                      showConfirmDeleteModal: false,
                      documentToDelete: null,
                    })
                  }
                >
                  Cancel
                </button>
              </div>
            </Modal.Footer>
          </Modal>
        )}
        {this.renderPreviewModal()}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    ProjectDocument: state.ProjectStore.ProjectDocument,
    user: state.UserStore.UserProfile,
  };
};

export default connect(mapStateToProps)(HomeDocumentSection);



// WEBPACK FOOTER //
// ./src/Projects/Components/Document/homeowner-document-section.js